// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {
  ApiGatewayPathBuilder,
  CloudFunctionsPathBuilder,
  Env,
  IConsumerEnvironment,
  envToProjectId,
  getEnvDomain
} from 'shared-lib'

const env: Env = 'qa'
const projectId = envToProjectId[env]

const apiGatewayBuilder = new ApiGatewayPathBuilder(env)
const cloudFunctionsBuilder = new CloudFunctionsPathBuilder(env)

export const environment: IConsumerEnvironment = {
  production: false,
  env,
  firebaseConfig: {
    apiKey: 'AIzaSyCGXLhfW8Vfs0i0nv0cU28uDhZOWYITJh4',
    appId: '1:112244431939:web:d2ec9267ed001fbef808f6',
    authDomain: `${projectId}.firebaseapp.com`,
    measurementId: 'G-SJ1JDPPLED',
    messagingSenderId: '112244431939',
    projectId,
    storageBucket: `${env}-content.instockdepot.com`,
  },
  services: {
    auth: apiGatewayBuilder.build('auth'),
    cloudFunctions: cloudFunctionsBuilder.build(),
    commerce: apiGatewayBuilder.build('commerce'),
    content: apiGatewayBuilder.build('content'),
    customer: apiGatewayBuilder.build('customer'),
    events: apiGatewayBuilder.build('events'),
    files: apiGatewayBuilder.build('files'),
    integration: apiGatewayBuilder.build('integration'),
    messaging: apiGatewayBuilder.build('messaging'),
    notifications: apiGatewayBuilder.build('notifications'),
    product: apiGatewayBuilder.build('product'),
    productItem: apiGatewayBuilder.build('productItem'),
    registration: apiGatewayBuilder.build('registration'),
    seller: apiGatewayBuilder.build('seller'),
    user: apiGatewayBuilder.build('user'),
  },
  _business_EmailActionRoute: `https://${getEnvDomain(env, 'app.instockdepot.com')}/#/auth/actions`,
  algoliaAppId: '04YGJWJ3MF',
  algoliaSearchKey: '11b11ac95c8094d4ae5f0d6902520aaf',
  // We can turn authentication off in case we are using this application inside and SDK and do not want to have any authentication
  authentication: false, // Look to the auth guard for use of this value
  basePlatformHost: getEnvDomain(env, 'app.instockdepot.com'),
  cdnCname: getEnvDomain(env, 'content.instockdepot.com'),
  emailVerificationEmailTemplateId: '2LKYubs8e8JqMm17XrZW',
  passwordRecoveryEmailTemplateId: 'GQKsG5Wnv9sWJ9uY3aDf',
  stripePublishableKey: 'pk_test_51LLE3FA5ujVDaDChOhQQCw0oRESOuhLM1RHLLMF37uFggCoNRGPiwkfX8mAzRQxAQJeW5PqnkQrVXoJWiCSpqLiG00Lyjhe5BZ',
  tenant: {
    appConfigBaseURL: `https://${getEnvDomain(env, 'content.instockdepot.com')}/assets/bootstrap`,
    defaultTenant: 'construction.qa.instockdepot.app',
  },
  tenantId: 'B2C-USER-7o45s',
  themesEnabled: true,
  v2ReCaptcha: '6LenH1MgAAAAAAc6KDr-_0zDFsgdKa8ZhFINlS65',
  version: 'e6f7b30',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
